export default __webpack_public_path__ + "static/media/ic_stat3.9a50dbba.svg";